var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headers",on:{"click":function($event){return _vm.$router.push('/collect/indexPage')}}},[_c('img',{staticClass:"headerimg",attrs:{"src":_vm.header_cover,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }